import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/components/loader/loader.component';

@Component({
  selector: 'csd-root',
  standalone: true,
  // The global loader lives at the root (not the shell) so it also covers the
  // pre-shell flows — sign-in, callback, and the FCRA/org guard-phase API calls.
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
